import React from 'react';
import InlineScroll from 'src/components/InlineScroll/InlineScroll.jsx';

import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { TwoParticipantsSportsTabState } from './TwoParticipantsSportsTabState';
import { FilterTabs } from 'src/components/Filters/FilterTabs';

interface PropsType {
    sportState: TwoParticipantsSportsTabState;
}

export const MenuScrollRegion = observer('MenuScrollRegion', (props: PropsType) => {
    const appState = useAppStateContext();
    const { sportState } = props;
    const regions = appState.tagsState.regions;

    return (
        <div className='two-participants-events-filter'>
            <InlineScroll>
                <FilterTabs
                    available={regions}
                    active={sportState.currentRegion}
                    onChange={sportState.changeRegion}
                />
            </InlineScroll>
        </div>
    );
});
